<template>
  <div>
    <v-card class="pa-3 mb-5" outlined>
      <div>
        <strong>Usia Relawan</strong>
      </div>

      <v-divider class="my-2"></v-divider>

      <Cusia />
    </v-card>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";

import Cusia from "@/components/chart/relawan/data/usia";

export default {
  components: {
    Cusia,
  },

  data: () => ({
    session: "",

    tps: [],

    refKab: [],
    refKec: [],
    refKel: [],
    refTps: [],

    kec_id: "",
    kel_id: "",
    tps_id: "",
  }),

  async mounted() {
    this.session = await JSON.parse(Cookie.dec(Cookie.get("myCookie")));
  },

  methods: {},
};
</script>
